import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button, ModalBody, ModalFooter } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import { ReactComponent as DisconnectedSvg } from "../../assets/disconnected.svg";

const DisconnectedModal = () => {
  const rootStore = useContext(RootStoreContext);
  const { isNativeApp } = rootStore.commonStore;
  const [t] = useTranslation(
    ["translation", "nativeapp"],
    translationHookOptions
  );

  return (
    <>
      <ModalBody>
        <div className="connection-error">
          <h4 className="text-center">{t("disconnected_client")}</h4>
          <DisconnectedSvg />
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <div className="w-100 text-center">
          {t("disconnected_client_message")}
        </div>
        {(!isNativeApp || rootStore.commonStore.isOnline) && ( <>
        <Button color="dark" size="sm" onClick={() => window.location.reload()}>
          {t("disconnected_client_reload")}
        </Button>
        </>)}
        {(isNativeApp && rootStore.commonStore.isOnline) && (
          <>
            <div className="w-100 text-center">
              {t("login_method_separator")}
            </div>
          </>)}

          {isNativeApp && (
          <>
            <Button
              tag="a"
              href="/player/offline"
              color="dark"
              size="sm"
              className="text-white"
            >
              {t("signalr_disconnected_go_offline", { ns: "nativeapp" })}
            </Button>
          </>
        )}
      </ModalFooter>
    </>
  );
};

export default observer(DisconnectedModal);
